import React, { useState } from "react";
import { useLocation } from "react-router-dom";
// import "./SurveyPage.css";

const SurveyPage = () => {
  const location = useLocation();

  const survey = location.state?.survey;

  const [answers, setAnswers] = useState({});

  if (!survey) {
    return <h3>No Survey Found</h3>;
  }

  const handleAnswerChange = (questionId, optionId, type) => {
    if (type === "multiple_answers") {
      const currentAnswers = answers[questionId] || [];

      if (currentAnswers.includes(optionId)) {
        setAnswers({
          ...answers,
          [questionId]: currentAnswers.filter(
            (id) => id !== optionId
          ),
        });
      } else {
        setAnswers({
          ...answers,
          [questionId]: [...currentAnswers, optionId],
        });
      }
    } else {
      setAnswers({
        ...answers,
        [questionId]: optionId,
      });
    }
  };

  console.log("Selected Answers:", answers);

  return (
    <div className="container py-4">
      <div className="card shadow p-4 rounded-4">
        <h2 className="mb-2">{survey.title}</h2>

        <p className="text-muted mb-4">
          {survey.description}
        </p>

        {survey.questions?.map((question, index) => (
          <div key={question.id} className="mb-4">
            <h5>
              {index + 1}. {question.question}
            </h5>

            <div className="mt-3">
              {question.options?.map((option) => (
                <div
                  key={option.id}
                  className="form-check mb-2"
                >
                  {question.type === "multiple_answers" ? (
                    <input
                      type="checkbox"
                      className="form-check-input"
                      id={`option-${option.id}`}
                      checked={
                        answers[question.id]?.includes(
                          option.id
                        ) || false
                      }
                      onChange={() =>
                        handleAnswerChange(
                          question.id,
                          option.id,
                          question.type
                        )
                      }
                    />
                  ) : (
                    <input
                      type="radio"
                      className="form-check-input"
                      name={`question-${question.id}`}
                      id={`option-${option.id}`}
                      checked={
                        answers[question.id] === option.id
                      }
                      onChange={() =>
                        handleAnswerChange(
                          question.id,
                          option.id,
                          question.type
                        )
                      }
                    />
                  )}

                  <label
                    className="form-check-label ms-2"
                    htmlFor={`option-${option.id}`}
                  >
                    {option.text}
                  </label>
                </div>
              ))}
            </div>
          </div>
        ))}

        <button
          className="btn btn-primary mt-3"
          onClick={() => console.log(answers)}
        >
          Submit Survey
        </button>
      </div>
    </div>
  );
};

export default SurveyPage;